<template>
  <v-container fluid>
    <!-- Encabezado -->
    <!-- <v-row class="mb-1" align="center">
      <v-col cols="12" md="8">
        <div class="text-h6 font-weight-bold">
          Generar factura
        </div>

        <div class="text-body-3 grey--text text--darken-1 mt-1">
          Captura los datos fiscales o selecciona una plantilla guardada.
        </div>
      </v-col>
    </v-row> -->

    <!-- Loading general -->
    <v-row v-if="loading">
      <v-col cols="12">
        <v-card class="pa-1 text-center" outlined>
          <v-progress-circular
            indeterminate
            color="primary"
            size="36"
          />

          <div class="mt-3 text-body-2 grey--text">
            Cargando información de facturación...
          </div>
        </v-card>
      </v-col>
    </v-row>

    <!-- Contenido -->
    <v-row v-else dense>
      <!-- Formulario -->
      <v-col cols="12" lg="8" md="7">
        <v-card outlined class="rounded-lg">
          <v-card-title class="pb-4">
            <v-icon left color="primary">
              mdi-file-document-edit-outline
            </v-icon>
            Datos de facturación
          </v-card-title>

          <v-card-subtitle>
            Completa la información requerida para emitir la factura.
          </v-card-subtitle>

          <v-divider />

          <v-card-text>
            <facturar-form
              v-model="factura"
              :formas-pago="formasPago"
              :loading="facturando"
            @facturar="crearFactura"
            @limpiar="limpiarSeleccionPlantilla"
            />
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Plantillas -->
      <v-col cols="12" lg="4" md="5">
        <v-card outlined class="rounded-lg">
          <!-- <v-card-title class="pb-4">
            <v-icon left color="primary">
              mdi-card-multiple-outline
            </v-icon>
            Plantillas
          </v-card-title>

          <v-card-subtitle>
            Selecciona una plantilla para llenar el formulario automáticamente.
          </v-card-subtitle>

          <v-divider /> -->

          <v-card-text>
            <template v-if="plantillas.length">
              <plantillas-cards
                :plantillas="plantillas"
                :plantilla-seleccionada="plantillaSeleccionada"
                @seleccionar="seleccionarPlantilla"
              />
            </template>

            <template v-else>
              <div class="text-center py-8">
                <v-icon size="48" color="grey lighten-1">
                  mdi-file-search-outline
                </v-icon>

                <div class="text-subtitle-2 mt-3">
                  No hay plantillas disponibles
                </div>

                <div class="text-body-2 grey--text mt-1">
                  Cuando tengas plantillas guardadas aparecerán aquí.
                </div>
              </div>
            </template>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Error -->
    <v-snackbar
      v-model="snackbar.visible"
      color="error"
      timeout="4000"
      top
      right
    >
      {{ snackbar.message }}

      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="snackbar.visible = false"
        >
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import PlantillasCards from '@/components/facturacion/PlantillasCards.vue';
import FacturarForm from '@/components/facturacion/FacturarForm.vue';



export default {
  name: 'FacturarView',

  components: {
    PlantillasCards,
    FacturarForm
  },

  data() {
    return {
      facturando: false,
      loading: false,
      formasPago: [],
      plantillas: [],
      plantillaSeleccionada: null,
      factura: {
          rfc: '',
          nombreCliente: '',
          usoCfdi: '',
          regimenFiscal: '',
          codigoPostal: '',
          metodoPago: '',
          correo: '',
          detalles: [
            {
              claveProducto: '',
              noIdentificacion: '',
              descripcionProducto: '',
              unidad: '',
              cantidad: 1,
              total: ''
            }
          ]
        },
      //factura: { ...FACTURA_DEFAULT },
      snackbar: {
        visible: false,
        message: ''
      }
    };
  },

  mounted() {
    this.cargarDatosIniciales();
  },

  methods: {
    
    async crearFactura(request) {
      if (this.facturando) {
        return;
      }
      this.facturando = true;
       this.$http.post(`facturacion/genera`, request)
        .then(response => {
          if (response.status === 200) {
              this.$swal.fire({
                        toast: true,
                        position: 'top-end',
                        title: `Factura  ${response.data.uuid}`,
                        text: "Factura enviada correctamente",
                        icon: 'success',
                        confirmButtonText: 'Cerrar',
                        showCloseButton: false,
                        showConfirmButton: true,
                        timer: 7000,
                        width: '40%',  // Más ancho
                        backdrop: false // Evita que la alerta haga scroll al inicio
                    })
                    this.limpiarFactura()
          }
        })
        .catch(err => console.error('Error al conectar con SignalR:', err))
        .finally(() => {
            this.facturando = false
        });

    },
    async cargarDatosIniciales() {
      this.loading = true;

      try {
        const [plantillasResponse, formasPagoResponse] = await Promise.all([
          this.$http.get('Facturacion/plantillas'),
          this.$http.get('Facturacion/formas-pago')
        ]);

        this.plantillas = plantillasResponse.data || [];
        this.formasPago = formasPagoResponse.data || [];
      } catch (error) {
        console.error('Error al cargar datos de facturación:', error);

        this.mostrarError('No se pudo cargar la información de facturación.');
      } finally {
        this.loading = false;
      }
    },

    seleccionarPlantilla(facturaDesdePlantilla, plantillaOriginal) {
          this.plantillaSeleccionada = plantillaOriginal;

          this.factura = {
            ...this.factura,
            ...facturaDesdePlantilla,

            correo:
              facturaDesdePlantilla.correo ||
              this.factura.correo ||
              this.getEmail ||
              '',

            detalles:
              facturaDesdePlantilla.detalles &&
              facturaDesdePlantilla.detalles.length
                ? facturaDesdePlantilla.detalles
                : this.factura.detalles
          };
        },
    limpiarSeleccionPlantilla() {
      this.plantillaSeleccionada = null;
    },
    limpiarFactura() {
      this.factura = {  };
      this.plantillaSeleccionada = null;
    },

    mostrarError(message) {
      this.snackbar.message = message;
      this.snackbar.visible = true;
    },

    async obtenerPlantillas() {
      try {
        // Cambia la ruta por la de tu API real
        const response = await this.$axios.get('/api/plantillas-factura');

        this.plantillas = response.data || [];
      } catch (error) {
        console.error('Error al obtener plantillas:', error);
        this.plantillas = [];
      }
    }
  }
};
</script>